import { InjectionToken } from "@angular/core";

export const IFRAME_URL: InjectionToken<string> = new InjectionToken<string>("extjs-iframe-url");
